module.exports = __webpack_public_path__ + "img/villa_giulia_hero_card.4480c79d.png";